import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { ScheduleReportTable } from '../../report/ScheduleReportTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { GroupVisitsByPatientTable } from '../../groups/GroupVisitsByPatientTable';

const WeeklyTotalsPatientDataTable = createQueryDataTable('schedule-report-totals-patient');
type RowType = RowOfQueryDataTable<typeof WeeklyTotalsPatientDataTable>;

const columnDefinitions = WeeklyTotalsPatientDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true
	},
	{
		header: 'MR#',
		key: 'patientCode',
		sortable: true
	},
	{
		header: 'Insurance',
		key: 'primaryInsurance',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function WeeklyTotalsPatientTable(props: PropsOfQueryDataTable<typeof WeeklyTotalsPatientDataTable>) {
	return (
		<GroupVisitsByPatientTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-patient"
			tableComponent={ScheduleReportTable}
			{...props}
		/>
	);
}
